import { render, staticRenderFns } from "./AnnouncementRow.vue?vue&type=template&id=4c362047&scoped=true"
import script from "./AnnouncementRow.vue?vue&type=script&lang=js"
export * from "./AnnouncementRow.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementRow.vue?vue&type=style&index=0&id=4c362047&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c362047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c362047')) {
      api.createRecord('4c362047', component.options)
    } else {
      api.reload('4c362047', component.options)
    }
    module.hot.accept("./AnnouncementRow.vue?vue&type=template&id=4c362047&scoped=true", function () {
      api.rerender('4c362047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AnnouncementRow.vue"
export default component.exports